module.exports = __webpack_public_path__ + "img/submit.97149aa2.png";